import React from 'react'
import { useIntl } from 'react-intl'
import { Icons } from 'msp-components'
import { useCookie, useNavigation } from 'msp-integrations'
import * as S from './AccountLogout.styles'
import * as T from './AccountLogout.types'
import { useQueryClient } from '@tanstack/react-query'

const AccountLogout = ({ customer }: T.AccountLogoutProps) => {
  const { formatMessage } = useIntl()
  const navigate = useNavigation()
  const { eventTracking } = useCookie()

  // Get native app state for show/hide elements
  // appMode: 0 for web, 1 for app
  const queryClient = useQueryClient()
  const { appMode } = queryClient.getQueryData<{ appMode: string }>([
    'native-app-state'
  ])

  const onSignoutClick = async () => {
    await customer.logout()
    eventTracking('logout', { loggedIn: 0 })
    navigate('/login')
  }

  return (
    <>
      <div className={S.AccountLogoutWrapper}>
        <div className={S.AccountLogoutCustomerName}>
          {[customer.firstName, customer.lastName].filter(Boolean).join(' ')}
        </div>
        {appMode !== '1' && (
          <div className={S.AccountLogoutButton} onClick={onSignoutClick}>
            <Icons iconName='Logout' height='20px' width='20px' />
            {formatMessage({
              defaultMessage: 'Logout',
              id: 'account.logout_button.button.log_out'
            })}
          </div>
        )}
      </div>
    </>
  )
}

export default AccountLogout
